import type { BetSlipState } from '../types';

interface BetPlacementFailedPayload {
  errorCode: BetSlipState['errorCode'];
  errorResponse?: BetSlipState['errorResponse'];
}

const betPlacementFailed = (
  state: BetSlipState,
  { errorCode, errorResponse }: BetPlacementFailedPayload
): BetSlipState => ({
  ...state,
  errorCode,
  isLocked: false,
  errorResponse
});

export default betPlacementFailed;
